// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"265e00ed","76":"ef97cd13","99":"b06d02b0","264":"800fd0ca","425":"6e0457f1","439":"616cecd5","466":"5c381b10","476":"8221fce5","518":"5ad59e4b","540":"5e4ffca0"}[chunkId] + ".chunk.js";
};